<template>
    <div>
      <patent-certificate-list></patent-certificate-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  
  